import { cn } from "~/lib/utils";

/**
 * Tailwind-scoped styling for sanitised rich-text HTML (`renderDescriptionHtml`).
 *
 * This project has no `@tailwindcss/typography` plugin, so `prose` is not a real
 * class here — writing it produces silently unstyled markup, which is exactly
 * what P8-13 shipped on the first pass (paragraphs with no spacing between
 * them). These arbitrary variants ARE the prose styles.
 *
 * Extracted from the PDP in P8-13 so the two surfaces rendering the same
 * sanitised document — product descriptions and blog bodies — can't drift into
 * styling the same node types differently. `richTextProse` takes the size and
 * colour, since a PDP description tab is secondary copy while an article body
 * is the page's main content.
 */
const STRUCTURE = [
  "[&_p]:my-3 [&_h2]:mt-5 [&_h2]:mb-2 [&_h2]:font-semibold [&_h2]:text-fg",
  "[&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:font-semibold [&_h3]:text-fg",
  "[&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-1",
  "[&_a]:font-medium [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2",
  "[&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-4 [&_blockquote]:italic",
  "[&_table]:my-3 [&_table]:w-full [&_table]:text-left [&_th]:py-1 [&_th]:pr-4 [&_th]:font-semibold [&_td]:py-1 [&_td]:pr-4",
];

/** Secondary copy — the PDP description tab. */
export const richTextProseCompact = cn(
  "max-w-prose text-sm leading-relaxed text-fg-muted",
  "[&_h2]:text-base",
  ...STRUCTURE,
);

/** Primary page content — a blog article body. */
export const richTextProseArticle = cn(
  "max-w-prose text-base leading-relaxed text-fg",
  "[&_h2]:text-xl [&_h3]:text-lg",
  ...STRUCTURE,
);
